import React, { Component } from "react";
import { HotTable } from "@handsontable/react";
import { utils } from "~/utils";
import * as _ from "lodash";

class OETBasicInfo extends Component {
    constructor(props) {
        super(props);
        this.hotTableComponent = React.createRef();
    }

    render() {
        const { oet, nonSode, status } = this.props;
        if (nonSode) {
            delete nonSode.oet;
        }

        const data = oet ? this.getTestData({ ...nonSode, ...oet }) : [];
        const table_op = {
            width: "100%",
            height: 500,
            stretchH: "all",
            beforeChange: this.onBeforeHotChange,
            settings: {
                tableClassName: ["table", "table-bordered", "table-striped"],
                fillHandle: true,
                // disableVisualSelection: true,
                wordWrap: true,
                stretchH: "none",
                className: "htCenter htMiddle",
                colHeaders: this.getColHeaders(status),
                columns: this.getColumns(status),
                data
            }
        };
        return (
            <div>
                <HotTable currentHeaderClassName="thead-dark" ref={this.hotTableComponent} {...table_op} />
            </div>
        );
    }

    onBeforeHotChange = (changes, source) => {
        const hot = this.hotTableComponent.current.hotInstance;
        if (source === "edit") {
            const { oet, onItemsChange } = this.props;
            const [row, key, , newValue] = changes[0];
            const dataRow = hot.getSourceDataAtRow(row);
            const oldItem = oet.items.find(item => item.id === dataRow.id);
            let newItem = null;
            if (oldItem.hasOwnProperty(key)) {
                newItem = Object.assign({}, oldItem);
                newItem[key] = newValue;
            }
            onItemsChange({ oldItem, newItem });
        }
    };

    getColHeaders = () => ["Project", "Circle", "Approval ID", "Approval Date", "Approved QTY", "Budget"];

    getColumns = status => {
        // const is_editable = !(status > 0);
        return [
            {
                data: "project",
                editor: false,
                className: "htMiddle htCenter"
            },
            {
                data: "circle",
                editor: false,
                className: "htMiddle htCenter"
            },
            {
                data: "non_sode.id",
                editor: false,
                className: "htMiddle htCenter"
            },
            {
                data: "non_sode.approval_date",
                editor: false,
                className: "htMiddle htCenter"
            },
            {
                data: "non_sode.approved_quantity",
                editor: false,
                className: "htMiddle htCenter"
            },
            {
                data: "non_sode.price",
                editor: false,
                className: "htMiddle htCenter"
            }
        ];
    };

    getTestData = oet => {
        const { itemID } = this.props;
        const { items, customer_purchase_order, non_sode } = oet;
        let filterItems = [];
        if (items) {
            filterItems = [...items];
            if (itemID) {
                filterItems = filterItems.filter(item => parseInt(item.id, 10) === parseInt(itemID, 10));
            }
        }

        if (items) {
            return _.orderBy(filterItems, ["item"], ["asc"]).map(item => ({
                ...item,
                project: customer_purchase_order.project,
                circle: customer_purchase_order.circle,
                ...(non_sode
                    ? {
                          non_sode: {
                              ...non_sode,
                              approval_date: utils.renderDate(non_sode.approval_date),
                              created_at: utils.renderDate(non_sode.created_at)
                          }
                      }
                    : {}),
                date: utils.renderDate(customer_purchase_order.create_at)
            }));
        }
        return [{}];
    };
}

export default OETBasicInfo;
